import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ProfileSetup.EmailPage.SetupProfileWizard', {
    stepProfileTitle: 'Set up your ApprovalMax Profile',
    stepInvitationsTitle: 'Your Invitations',
    stepInvitationsTitleMobile: 'You were invited to the following organisations:',
    practiceInvitationsPopupTitle: 'Invitations to Business Accounts',
    nextButton: 'Next',
});
